import { createLocale } from "./createLocale";

export const lv = createLocale({
  header: {
    title: "Ej globāli. 2 $ par Short. Jebkura valoda!",
    subtitle: "🔥Maksājiet tikai par rezultātu – no $0.089 līdz $0.009 sekundē🔥",
  },
  steps: {
    uploadVideo: "Augšupielādēt video",
    selectLanguages: "Izvēlēties valodas",
    conversionResult: "Konvertēšana un rezultāts",
  },
  upload: {
    dragAndDrop: "Ievelciet un nometiet savu video failu šeit",
    orClickToSelect: "vai noklikšķiniet, lai izvēlētos",
    supportedFormats: "Atbalstītie formāti: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maksimālais faila izmērs: 200 MB",
    maxDuration: "• Maksimālais ilgums: 30 sek",
    chooseFile: "Izvēlēties failu",
    selectedFile: "Izvēlētais fails:",
    size: "Izmērs:",
    fileTypeError: "Lūdzu, izvēlieties video failu",
    fileSizeError: "Faila izmērs ({size} MB) pārsniedz maksimālo limitu 200 MB",
    durationError: "Video ilgums ({duration} sek) pārsniedz maksimālo limitu 30 sek",
    fileReadError: "Nevar nolasīt video failu. Lūdzu, mēģiniet citu failu.",
  },
  languages: {
    sourceAudioLanguage: "Avota audio valoda",
    targetAudioLanguage: "Mērķa audio valoda",
    selectLanguage: "Izvēlieties valodu...",
  },
  conversion: {
    replaceAudio: "Klonēt manu balsi",
    uploadVideoAndSelectLanguages: "Augšupielādējiet video un izvēlieties valodas, lai turpinātu",
  },
  nav: {
    blog: "Blogs",
  },
  footer: {
    privacyPolicy: "Privātuma politika",
    termsOfUse: "Lietošanas noteikumi",
  },
  languageOptions: {
    lv: "Latviešu",
  },
});
